import apiWorker from '../apiWorker'

export default {

    findByContact : (contact_id) =>  apiWorker('get',  `/api/v1/core/contact_alerts/findByContact/${contact_id}`),

}
